import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a3fc7138&"
var script = {}
import style0 from "./style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports